import React from 'react';
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  SignalIcon
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-dark-900 border-t border-cyan-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <Logo size="md" />
            </div>
            <p className="text-ocean-100/60 mb-4 max-w-md">
              Chuyên cung cấp giải pháp thiết kế website, ứng dụng di động và dịch vụ marketing số
              chuyên nghiệp cho doanh nghiệp.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-ocean-100/60">
                <PhoneIcon className="w-5 h-5 mr-2 text-cyan-400" />
                <span>0903954852</span>
              </div>
              <div className="flex items-center text-ocean-100/60">
                <EnvelopeIcon className="w-5 h-5 mr-2 text-cyan-400" />
                <span>smarteravn@gmail.com</span>
              </div>
              <div className="flex items-center text-ocean-100/60">
                <MapPinIcon className="w-5 h-5 mr-2 text-cyan-400" />
                <span>22/2 Đường số 4, P.Bình Hưng Hòa, Q.Bình Tân, TP.HCM</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Liên kết nhanh</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Trang chủ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Giới thiệu
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Liên hệ
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Tra cứu ticket
                </Link>
              </li>
              <li>
                <a href="https://demo.smartera.uk/" target="_blank" rel="noopener noreferrer" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Demo
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Portal */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Khách hàng</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/login" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Đăng nhập
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Đăng ký
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Bảng điều khiển
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-ocean-100/60 hover:text-cyan-400 transition-colors">
                  Hỗ trợ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-cyan-500/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-wrap items-center space-x-6 mb-4 md:mb-0">
              <Link to="/terms" className="text-ocean-100/50 hover:text-cyan-400 text-sm transition-colors">
                Điều khoản sử dụng
              </Link>
              <Link to="/privacy" className="text-ocean-100/50 hover:text-cyan-400 text-sm transition-colors">
                Chính sách bảo mật
              </Link>
              <a
                href="https://smartera.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-ocean-100/50 hover:text-cyan-400 text-sm transition-colors"
              >
                Website chính
              </a>
              <a
                href="https://giaiphapthietkeweb.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-ocean-100/50 hover:text-cyan-400 text-sm transition-colors"
              >
                Blog
              </a>
            </div>

            <div className="flex items-center text-ocean-100/50 text-sm">
              <SignalIcon className="w-4 h-4 text-cyan-400 mr-2" />
              © {new Date().getFullYear()} <span className="font-semibold text-cyan-400 mx-1">Smartera</span>. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
